// Entry point for the build script in your package.json
import "trix"
import "@rails/actiontext"
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

import 'alpine-turbo-drive-adapter'
import Alpine from 'alpinejs'

window.Turbo = Turbo

window.Alpine = Alpine
Alpine.start()

document.addEventListener('turbo:before-fetch-request', (e) => {
  Turbo.navigator.delegate.adapter.showProgressBar();

  // https://github.com/hotwired/turbo/issues/491#issuecomment-986866952
  if (e.target instanceof HTMLFormElement) {
    const { fetchOptions: { method, headers } } = e.detail;

    if (method.match(/get/i) && e.target.dataset.turboStreaming === 'true') {
      headers.Accept = ['text/vnd.turbo-stream.html', headers.Accept].join(', ');
    }
    else if (e.target.dataset.turboStreaming === 'false') {
      headers.Accept = 'text/html';
    }
  }
});

['turbo:frame-render', 'turbo:before-stream-render'].forEach((e) => {
  document.addEventListener(e, () => {
    Turbo.navigator.delegate.adapter.progressBar.hide();
  });
});

document.addEventListener('turbo:load', (e) => {
  if (window.location.hash.substring(1) == 'search') {
    document.getElementById('searchInput').focus();
  }
});
